import { useState, useEffect, memo } from "react";
import axios from "../customAxios.js";
import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { dateToDatabase } from "../utils/functions";
import es from "date-fns/locale/es";
import CustomTableNew from "../components/CustomTableNew.jsx";
import { useAuth } from "../hooks/useAuth.jsx";

const Picking = (props) => {
  // currentUser
  const { user } = useAuth();
  // array's
  const [companies, setCompanies] = useState([]);
  const [pickings, setPickings] = useState([]);

  // view helpers
  const [loading, setLoading] = useState(false);

  // filters stored at localStorage
  const [startDate, setStartDate] = useState(
    localStorage.getItem("pickingsFilter")
      ? new Date(JSON.parse(localStorage.getItem("pickingsFilter")).startDate)
      : new Date(new Date().setDate(new Date().getDate()))
  );
  const [endDate, setEndDate] = useState(
    localStorage.getItem("pickingsFilter")
      ? new Date(JSON.parse(localStorage.getItem("pickingsFilter")).endDate)
      : new Date()
  );
  const [pickingStatus, setPickingStatus] = useState([
    { value: "pending", label: "Pendiente" },
    { value: "ready_to_print", label: "Listo para Imprimir" },
    { value: "send_to_client", label: "Enviado a la cola de impresión" },
    { value: "printed", label: "Impreso" },
    { value: "failed", label: "Fallido" },
  ]);

  const [statusFilter, setStatusFilter] = useState(
    localStorage.getItem("pickingsFilter")
      ? JSON.parse(localStorage.getItem("pickingsFilter")).statusFilter
      : "all"
  );
  const [companyFilter, setCompanyFilter] = useState(
    localStorage.getItem("pickingsFilter")
      ? JSON.parse(localStorage.getItem("pickingsFilter")).companyFilter
      : "all"
  );

  const [orderFilter, setOrderFilter] = useState(
    localStorage.getItem("pickingsFilter")
      ? JSON.parse(localStorage.getItem("pickingsFilter")).orderFilter
      : ""
  );
  const [orderFilterInput, setOrderFilterInput] = useState(orderFilter);

  const fetchCompanies = async () => {
    setLoading(true);

    try {
      const { data } = await axios.get("companies/all_admin_companies")
      setCompanies(data);
    } catch (error) {
     console.error(`Error obteniendo las companies: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchPickups = async () => {
    setLoading(true);
    try {
      const { data: { order_pickups } } = await axios.get("get_order_pickup",
        {
          params: {
            start_date: dateToDatabase(startDate),
            end_date: dateToDatabase(endDate),
            company: companyFilter,
            state: statusFilter,
            order_id: orderFilter,
          },
        })
      setPickings(order_pickups);
    } catch (error) {
     console.error(`Error al obtener los pickups: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    fetchPickups();
    localStorage.setItem(
      "pickingsFilter",
      JSON.stringify({
        startDate,
        endDate,
        statusFilter,
        orderFilter,
        companyFilter,
      })
    );
  }, [statusFilter, companyFilter, startDate, endDate, orderFilter]);

  const headerTable = [
    { columnName: "Fecha Picking", dbName: "created_at", enabled: true },
    { columnName: "Conductor", dbName: "driver_full_name", enabled: true },
    { columnName: "Orden ruta", dbName: "route", enabled: true },
    { columnName: "Orden", dbName: "order.id", enabled: true },
    { columnName: "Delivery", dbName: "delivery.id", enabled: true },
    { columnName: "Estado", dbName: "state", enabled: true },
    {
      columnName: "Tracking",
      dbName: "delivery.courier_tracking_number",
      enabled: true,
    },
    {
      columnName: "Seller",
      dbName: "seller.company.social_reason",
      enabled: true,
    },
  ];

  return (
    <>
      <Grid item xs={12} className="mg-t-20">
        <h2>Picking</h2>
      </Grid>

      <Grid item xs={12} sm className="flex-left">
        <Grid container>
          <Grid item xs={4} sm="auto" className="input-date-filter">
            <FormControl fullWidth variant="outlined">
              <TextField
                variant="outlined"
                label="Buscar ID Orden"
                name="order_id"
                value={orderFilterInput}
                onChange={(e) => setOrderFilterInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setOrderFilter(orderFilterInput);
                  }
                }}
                onBlur={(e) => {
                  setOrderFilter(orderFilterInput);
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm className="flex-left filters-container">
        <div className="row-container request-search-container">
          <Grid container>
            <Grid item xs={3} sm="auto" className="input-date-filter">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
              >
                <DatePicker
                  label="Fecha de inicio"
                  value={startDate}
                  onChange={(newValue) => {
                    if (endDate < newValue) {
                      let newEndDate = new Date(newValue);
                      newEndDate.setDate(newEndDate.getDate());
                      setEndDate(newEndDate);
                    }
                    setStartDate(newValue);
                  }}
                  className="mg-r-10"
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3} sm="auto" className="input-date-filter">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
              >
                <DatePicker
                  label="Fecha de fin"
                  value={endDate}
                  onChange={(newValue) => {
                    if (newValue < startDate) {
                      let newStartDate = new Date(newValue);
                      newStartDate.setDate(newStartDate.getDate());
                      setStartDate(newStartDate);
                    }
                    setEndDate(newValue);
                  }}
                  disabled={startDate === null}
                  className="mg-r-10 mg-l-10"
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3} sm="auto" className="input-date-filter">
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="select-service-filter">
                  Estado Delivery
                </InputLabel>
                <Select
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                  }}
                  input={<OutlinedInput id="select-status-filter" />}
                  IconComponent={() => (
                    <i className="material-icons-outlined">expand_more</i>
                  )}
                >
                  <MenuItem key={"all"} value={"all"}>
                    Todos
                  </MenuItem>
                  {pickingStatus.map(({ value, label }, index) => (
                    <MenuItem key={index} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} sm="auto" className="input-service-filter">
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="select-service-filter">Empresa</InputLabel>
                <Select
                  value={companyFilter}
                  onChange={(e) => {
                    setCompanyFilter(e.target.value);
                  }}
                  input={<OutlinedInput id="select-status-filter" />}
                  IconComponent={() => (
                    <i className="material-icons-outlined">expand_more</i>
                  )}
                >
                  <MenuItem key={"all"} value={"all"}>
                    Todas
                  </MenuItem>
                  {companies.map(({ id, social_reason }, index) => (
                    <MenuItem key={index} value={id}>
                      {social_reason}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid container>
        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <CustomTableNew
              user_type_url_path={""}
              filterByDate={startDate !== null && endDate !== null}
              headerTable={headerTable}
              selected={"none"}
              setSelected={"none"}
              openCollapseButton={true}
              openCollapseTooltip={"Ver más"}
              openCollapseIcon={
                <i className="material-icons-outlined icon-actions-panel-test">
                  add_circle_outline
                </i>
              }
              collapseType={"order-pickups"}
              hasPagination={false}
              editable={false}
              filterStates={{ startDate, endDate, statusFilter, companyFilter }}
              pageData={pickings}
              setPageData={setPickings}
              loadingPageData={loading}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(Picking);
